/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {delegateTransfer} from '../api'

export const useMutationDelegateTransfer = createReactQueryMutationHook('delegateTransfer', delegateTransfer)
